// Port of api/fuel/app/classes/insights/player/games.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

export default Segment.extend({
	name: 'games',
	requires: ['init'],
	types: [Constants.TYPE_USER],
	detail: ['games'],
	run: function() {
		var limit = this._detail ? 250 : 5
		var games = {}
		var playKeys = Object.keys(this._data.plays || {})

		for (var i = 0; i < playKeys.length; i++) {
			var play = this._data.plays[playKeys[i]]
			if (!games[play.g]) {
				games[play.g] = {
					g: parseInt(play.g, 10),
					players: 0,
					plays: 0,
					index: [],
					counts: [0, 0, 0, 0, 0],
					d: 0
				}
			}

			games[play.g].plays += play.c
			games[play.g].counts[(play.pl > 6) ? 4 : play.pl - 2] += play.c
			games[play.g].index = Array.from(new Set(games[play.g].index.concat(play.playersIndex)))
			if (play.d > games[play.g].d) games[play.g].d = parseInt(play.d, 10)
		}

		var list = Object.keys(games).map(function(key) { return games[key] })
		var total = list.length
		list = Util.sort_by_field(list, 'plays', 'desc')
		if (list.length > limit) list = list.slice(0, limit)
		for (var j = 0; j < list.length; j++) this._references.games.push(parseInt(list[j].g, 10))

		return {
			games: {
				total: total,
				games: list
			}
		}
	}
})
